const awsConfig = {
  aws_project_region: 'us-east-1',  // Replace with your region
  aws_cognito_region: 'us-east-1', 
  aws_user_pools_id: 'us-east-1_x4S7fF5Nl',  // Your User Pool ID
  aws_user_pools_web_client_id: '16jnkpde2qggp492jqn5vhkpoq',  // Your App Client ID
  oauth: {
    domain: 'auth.hackerthread.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'https://hackerthread.com:3000/dashboard',  // After login
    redirectSignOut: 'https://hackerthread.com:3000/logout',  // After logout
    responseType: 'code',
  },
};

export default awsConfig;
